import Skeleton, { SkeletonTheme } from 'react-loading-skeleton'
import { Navigation } from 'swiper/modules'
import { Swiper, SwiperSlide } from 'swiper/react'
import { useMediaQuery } from 'usehooks-ts'

import { BannerInfo } from '@shared/generated'
import { cn } from '@shared/lib/cn'

import BannerItem from './item'

import styles from './styles.module.scss'

interface BannerCarouselProps {
  banners: (BannerInfo | null)[] | null;
  loading?: boolean;
}

function BannerSkeleton () {
  return (
    <SkeletonTheme>
      <Skeleton
        width={'100%'}
        style={{
          borderRadius: 12,
          aspectRatio: '2.8/1',
          minHeight: '180px',
        }}
      />
    </SkeletonTheme>
  )
}

export default function BannerCarousel (props: BannerCarouselProps) {
  const { banners = [], loading } = props

  const isTablet = useMediaQuery('(max-width: 768px')
  
  const showNavigation = !isTablet && banners && banners.length > 1

  if (loading) {
    return <BannerSkeleton />
  }

  return (
    <>
      {banners && banners.length > 0 && (
        <Swiper
          className={cn('_navigation-center', styles.swiper)}
          modules={[ Navigation ]}
          spaceBetween={20}
          navigation={showNavigation || false}
          loop={banners && banners.length > 1} // Отключаем loop для одного баннера
          breakpoints={{
            0: {
              slidesPerView: 'auto',
              centeredSlides: true,
            },
            769: {
              slidesPerView: 1,
            },
          }}
        >
          {banners &&
            banners.map((item) => {
              return (
                <SwiperSlide className={styles.slide} key={item?.id}>
                  <BannerItem
                    title={item?.name}
                    imageDesktop={item?.bannerSlide?.url}
                    imageMobile={item?.bannerMobileSlide?.url}
                    buttonLink={item?.url as string}
                    buttonText={item?.button_text as string}
                    openInNewTab={item?.optionOpenInNewWindow || false}
                  />
                </SwiperSlide>
              )
            })}
        </Swiper>
      )}
    </>
  )
}
